// Mock data for GetFit Fitness Studio

export const studioInfo = {
  name: "GetFit Fitness Studio",
  rating: 5.0,
  address: "145d Voortrekker Rd, Malmesbury, 7300",
  hours: "Monday-Friday: 05:00 PM - 7:00 PM | Closed: Saturday and Sunday",
  phone: "+27 62 355 4635",
  whatsapp: "+27 62 355 4635",
  email: "fitness@getfitstudio.co.za",
  inclusiveCommunity: true,
};

export const services = [
  {
    id: 1,
    title: "Personal Training",
    description: "One-on-one coaching tailored to your fitness goals. Get personalized workout plans, nutritional guidance, and constant support from our certified trainers.",
    icon: "User",
    image: "https://images.unsplash.com/photo-1534258936925-c58bed479fcb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwzfHxwZXJzb25hbCUyMHRyYWluaW5nfGVufDB8fHx8MTc3MjAwMzE2Mnww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: 2,
    title: "Group Training",
    description: "Train with a supportive community in our small group sessions. Experience the motivation of working out together while receiving individual attention.",
    icon: "Users",
    image: "https://images.unsplash.com/photo-1517836357463-d25dfeac3438?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwzfHxneW0lMjBmaXRuZXNzfGVufDB8fHx8MTc3MjAwMzE2NXww&ixlib=rb-4.1.0&q=85",
    classes: [
      { name: "Cardio", description: "High-energy cardiovascular workouts to boost endurance and burn calories" },
      { name: "Full Body Workout", description: "Comprehensive training targeting all major muscle groups" },
      { name: "Step", description: "Dynamic step aerobics for cardio fitness and coordination" },
      { name: "Strength and Mobility", description: "Build strength while improving flexibility and range of motion" },
    ],
  },
  {
    id: 3,
    title: "Fitness Coaching",
    description: "Comprehensive lifestyle coaching that goes beyond the gym. We help you build sustainable habits for long-term health and wellness.",
    icon: "Target",
    image: "https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwyfHxwZXJzb25hbCUyMHRyYWluaW5nfGVufDB8fHx8MTc3MjAwMzE2Mnww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: 4,
    title: "Strength & Conditioning",
    description: "Build muscle, increase strength, and improve athletic performance with our structured strength training programs designed for all fitness levels.",
    icon: "Dumbbell",
    image: "https://images.unsplash.com/photo-1534438327276-14e5300c3a48?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwxfHxneW0lMjBmaXRuZXNzfGVufDB8fHx8MTc3MjAwMzE2NXww&ixlib=rb-4.1.0&q=85",
  },
];

export const testimonials = [
  {
    id: 1,
    name: "Crystelle van Eeden",
    rating: 5,
    text: "I recently started, but as an old lady I feel that I can keep up and enjoy it tremendously. Much more than I thought I would. Jason and Louis made me feel welcome and at ease from the start. Love it!",
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop",
  },
  {
    id: 2,
    name: "Henriette Wadsworth",
    rating: 5,
    text: "The 05:00 am workouts are pure madness! But boy, oh boy, so worth it! And so much fun! And if I worked hard, I would get my own lap dance from Jason Roodt, what more can a girl ask for! These guys are not just gym coaches, they are life coaches as well. Not to mention the workouts that are planned ahead to make sure your whole body gets taken care of. And for the rate we pay, it's a steal! A sure win for me! Thank you Louis and Jason for all your patience and dedication to not just your gym, but to us as your members too.",
    image: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=150&h=150&fit=crop",
  },
  {
    id: 3,
    name: "Julie Nolan",
    rating: 5,
    text: "Louis is my personal trainer! He's very supportive as well as works out great sets that help me not injure my body. I lack motivation and he's there for me! I cherish our time together. Thanks Louis!",
    image: "https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=150&h=150&fit=crop",
  },
  {
    id: 4,
    name: "Anne Steyl",
    rating: 5,
    text: "From the first day I stepped into GetFit Fitness Studio I was overwhelmed and scared for the unknown. I was super impressed by the way that the instructors approached me. They were so caring and always cheering me on from the moment I walked into that Gym, I knew that no other gym have ever provided me with such support, motivation and laughs. If you are indecisive on which gym to join, I promise you, you won't regret setting your foot into GetFit Fitness Studio. Your body, mental health and future self will always be grateful, all YOU need to do, is make that first move to join! Do it for your body. Do it for your mind. But most importantly do it for YOU!",
    image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150&h=150&fit=crop",
  },
];

export const benefits = [
  {
    icon: "Users",
    title: "Community",
    description: "Join a supportive, inclusive fitness family",
  },
  {
    icon: "TrendingUp",
    title: "Results",
    description: "Proven methods that deliver real transformation",
  },
  {
    icon: "CheckCircle2",
    title: "Accountability",
    description: "Stay on track with personalized guidance",
  },
];
